import './Button.css';

function Button({ children, variant = 'primary', type = 'button', href, onClick, className = '' }) {
  const classNames = `btn btn--${variant} ${className}`.trim();

  if (href) {
    return (
      <a href={href} className={classNames} onClick={onClick}>
        {children}
      </a>
    );
  }

  return (
    <button type={type} className={classNames} onClick={onClick}>
      {children}
    </button>
  );
}

export default Button;
